import React, { ElementType, ReactNode } from 'react';
import { Typography, SxProps, Box } from '@mui/material';

type CAppSubTitleProps = {
	title: string | ReactNode;
	subtitle?: string | ReactNode;
	subtitleBoxComponent?: ElementType;
	icon?: ReactNode;
	sx?: SxProps;
	id?: string;
	className?: string;
};

const CAppSubTitle = (props: CAppSubTitleProps) => {
	const { id, title, subtitle, icon, sx, subtitleBoxComponent, className } = props;

	const subtitleComponent = (
		<span
			style={{
				lineHeight: '1.5',
				fontSize: '1rem',
				fontFamily: '"Cambo", Arial, Helvetica, sans-serif',
				fontWeight: 'normal',
				alignItems: 'center',
			}}
		>
			{subtitle}
		</span>
	);
	return (
		<Typography
			className={className}
			variant="h2"
			component="h2"
			id={id}
			sx={{
				marginTop: '40px',
				marginBottom: '14px',
				'& span.icon': {
					position: 'relative',
					top: '4px',
					marginRight: '8px',
				},
				'& span.subtitle': {
					position: 'relative',
					top: '0px',
				},
				...sx,
			}}
		>
			{icon ? <span className="icon">{icon}</span> : ''} {title}{' '}
			{subtitleComponent ? (
				<Box component={subtitleBoxComponent} className="subtitle">
					{' '}
					{subtitleComponent}
				</Box>
			) : (
				''
			)}
		</Typography>
	);
};

CAppSubTitle.defaultProps = {
	subtitleBoxComponent: 'span',
};

export default CAppSubTitle;
